<template>
    <loader-bar
        v-if="loading"
        ></loader-bar>
    <div
        v-else
        class="plan-item"
        >
        <div class="title-block">
            <div class="title-text">
                <slot name="title-text"></slot>
            </div>
        </div>
        <div class="detail-block">
            <h5 class="box">
                <slot name="detail-box-title"></slot>
            </h5>
            <div class="detail-top-block">
                <slot name="detail-top"></slot>
            </div>
            <div class="detail-img-block image-madori">
                <img
                    v-if="img_madori"
                    :src=img_madori.src
                    :alt="img_madori.alt"
                    />
                <img
                    v-else
                    src="../assets/noimg.jpg"
                    />
            </div>
            <div class="detail-middle-block">
                <slot name="detail-middle"></slot>
            </div>
            <image-slider 
                ref="slider"
                class="detail-slider-block"
                v-if="imgs_data_source.length"
                :data-source="imgs_data_source"
                :loop="sliderLoop"
                :max="sliderMax"
                :pswpOpened="pswp.opening"
                @pswp-view="pswpView"
                >
            </image-slider>
            <div class="detail-bottom-block">
                <slot name="detail-bottom"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    //components
    import LoaderBar from '../components/LoaderBar.vue';
    import ImageSlider from '../components/ImageSlider.vue';

    import 'photoswipe/style.css';
    import '../css/pswp.css';

    //functions
    import { viewd, obj2Qs } from '../modules/utils.js';
    import Pswp from '../modules/pswp.js';

    export default {
        name: 'PlanItem',
        props: [
            'bms_code', 'url_api',
            'slider-loop', 'slider-max'
        ],
        data() {
            return {
                loading: true,
                res: null,
                pswp: new Pswp()
            };
        },
        computed: {
            imgs_data_source() {
                if (!this.res || !Array.isArray(this.res.imgs)) {
                    return [];
                }
                return this.res.imgs.map(image => {
                    return {
                        id: image.id,
                        src: image.src,
                        alt: image.cmt,
                        type: image.type
                    };
                });
            },
            img_madori() {
                return this.imgs_data_source.find(image => image.type == 18);
            }
        },
        methods: {
            request() {
                const param = {
                    bukken: this.bms_code,
                    imgs: ''
                };
                const url = new URL(`?${obj2Qs(param)}`, this.url_api);

                this.loading = true;
                this.res = null;
                return fetch(url.href, {
                    mode: 'cors',
                    credentials: 'omit'
                }).then(res => res.json()).then(res => {
                    this.res = {};
                    //画像リスト
                    Array.isArray(res.imgs) && this.$set(this.res, 'imgs', res.imgs);
                }).catch(e => {
                    console.error(e);
                }).finally(() => {
                    this.loading = false;
                });
            },
            pswpView(image) {
                this.pswp.openByImg(image);
            }
        },
        watch: {
            imgs_data_source(ds) {
                //photoswipe data source reload
                this.pswp.load(ds);
            }
        },
        mounted() {
            if (this.bms_code) {
                //viewd after 0.5s, request bukken
                viewd(this.$el, 500).then(() => {
                    this.request();
                });
            } else {
                //hide
                this.loading = false;
            }
            this.pswp.on('image-changed', image => {
                this.$refs.slider.onImageChanged(image);
            });
        },
        unmounted() {
            this.pswp.destroy();
        },
        components: {
            LoaderBar,
            ImageSlider
        }
    }
</script>
<style scoped>
    img{
        max-width: 100%;
    }

    .plan-item{
        background: #003750;
        padding: 10px;

        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .title-block{
        padding: 10px;
    }
    .title-text{
        color: #fff;
    }

    .detail-block {
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding-bottom: 20px;
    }

    .box {
        border-bottom: solid 2px #003750;
        text-align: center;
        padding: 5px 0;
        font-size: 30px;
        width: 100%;
    }
    .detail-top-block{
        width: 95%;
        padding: 5px 0;
    }
    .detail-img-block{
        width: 100%;
    }
    .image-madori{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .image-madori img{
        object-fit: contain;
        width: 100%;
    }

    .detail-middle-block{
        /*width: 95%;*/
    }
    .detail-slider-block,.detail-bottom-block{
        width: 95%;
    }
</style>
